export enum ChartColors {
  Green = 'green',
  Orange = 'orange',
  Yellow = '#FFB600',
  Red = 'red',
}
